import React from 'react'
import { Link } from 'react-router-dom'
import styles from './List.module.less'
import { useTranslation } from 'react-i18next';
const Index = ({ data = [] }) => {
  const { i18n } = useTranslation()
  return (
    <ul className={styles.list}>
      {
        data && data.map(item => (
          <li key={item.qcmsdid}>
            <Link to={`/news/${item.qcmsdid}`} target="_blank"><img src={item.img} alt={item.title} /></Link>
            <h4><Link to={`/news/${item.qcmsdid}`} target="_blank">{item.title}</Link></h4>
            <p>{item.brief}</p>
            <span>{item.recordTime.split(' ')[0]}</span>
          </li>
        ))
      }
    </ul>
  )
}

export default Index
